module.exports = __webpack_public_path__ + "img/instagram.1b8cf5b0.png";